import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { FaUser, FaPhone, FaEnvelope, FaMapMarkerAlt, FaEdit,FaLock, FaTrash } from 'react-icons/fa';
import { Modal, message } from 'antd';
import DomainIcon from '../../assets/icons/domain.svg';
import ClientDomainInfo from './ClientDomainInfo';
import ClientPSWChange from './ClientPSWChange';
import { getClientInfo,deleteClient, getRoles } from '../../Utils/client/client';
import { getUserInfo } from '../../service/auth.service';
import { useSelector } from 'react-redux';



const ROLE_LABELS = {
  'superadmin': 'Administrateur',
  'client': 'Client',
  'domain_manager': 'Gérant de domaine',
  'exploitation_manager': 'Gérant d\'exploitation'
};

const ROLE_COLORS = {
  'superadmin': 'bg-rose-100 text-rose-700 border-rose-300',
  'client': 'bg-sky-100 text-sky-700 border-sky-300',
  'domain_manager': 'bg-amber-100 text-amber-700 border-amber-300',
  'exploitation_manager': 'bg-emerald-100 text-emerald-700 border-emerald-300'
};

const ClientInfo = ({ clientInfo }) => {
  const [showChangePsw, setShowChangePsw] = useState(false)
  const userRole = useSelector((state) => state.user.userRole.name);
  const [client_role_id, setClient_role_id] = useState(null);
  const [roles, setRoles] = useState([]);
  const [userRoleName, setUserRoleName] = useState('');

  
  let user = {};
  let domains = [];

  const fetchRoles = async () => {
    try {
      const res = await getRoles();
      setRoles(res.data);
      const client_role = res.data.find(role => role.name === 'client');
      if (client_role) {
        setClient_role_id(client_role.role_id);
      }
      
      // Find the user's role name
      const userRoleData = res.data.find(role => role.role_id === clientInfo?.user?.role_id);
      if (userRoleData) {
        setUserRoleName(userRoleData.name);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchRoles();
  }, [clientInfo]);


  if (!clientInfo) {
    const user = getUserInfo();
    clientInfo = getClientInfo(user.user_id);
  } else {
    user = clientInfo.user;
    domains = clientInfo.domains;
  }

  const handleDelete = (id) => {
    Modal.confirm({
      title: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
      content: 'Cette action est irréversible.',
      okText: 'Oui',
      okType: 'danger',
      cancelText: 'Non',
      onOk: async () => {
        try {
          await deleteClient(id);
          message.success('Utilisateur supprimé avec succès');
          navigate('/admin/client/all');
        } catch (error) {
          console.error('Error deleting client:', error);
          message.error('Failed to delete client');
        }
      }
    });
  };


  const navigate = useNavigate();

  return (
    <div className="mx-auto p-4">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-4">
            <h2 className="text-2xl font-bold text-gray-800">{user.company_name}</h2>
            {userRoleName && (
              <span className={`px-4 py-2 rounded-full text-sm font-semibold border-2 ${ROLE_COLORS[userRoleName] || 'bg-gray-100 text-gray-700 border-gray-300'}`}>
                {ROLE_LABELS[userRoleName] || userRoleName}
              </span>
            )}
          </div>
          <img
            src={`data:image/png;base64,${user.company_logo}`}
            alt="Company Logo"
            className="h-16 max-w-[120px] object-contain"
          />
        </div>
        <div className="space-y-4 mb-6 ">
          <InfoItem icon={<FaUser />} label="Gérant" value={(user?.first_name && user?.first_name !== 'null') ? `${user.first_name} ${user.last_name}` : "Non renseigné"} />
          <InfoItem icon={<FaPhone />} label="Téléphone" value={user.phone_number} />
          <InfoItem icon={<FaEnvelope />} label="Email" value={user.email} />
          <InfoItem icon={<FaMapMarkerAlt />} label="Adresse" value={user.address} /> 
          { clientInfo.user.role_id === client_role_id &&
            <InfoItem icon={<img src={DomainIcon} width={20} />} label="Domaines" value={domains.length > 0 ? `${domains.length} domaine(s)` : "Aucun domaine"} />
          }
        </div>

        {(userRole === 'admin' || userRole === 'superadmin') &&
          <div className="flex justify-end space-x-4">
            <Button
              className="bg-blue-600 hover:bg-blue-700 text-white flex items-center"
              onClick={() => navigate(`/admin/client/${user?.user_id}/edit`, { state: { clientInfo } })}
            >
              <FaEdit className="mr-2" />
              Modifier les informations
            </Button>

            <Button
              className="bg-yellow-500 hover:bg-yellow-600 text-white flex items-center"
              onClick={() => setShowChangePsw(!showChangePsw)}
            >
              <FaLock className="mr-2" />
              Modifier le mot de passe
            </Button>

            <Button
              className="bg-red-600 hover:bg-red-700 text-white flex items-center"
              onClick={() => { handleDelete(user.user_id)
              }}
            >
              <FaTrash className="mr-2" />
              Supprimer l'utilisateur
            </Button>
          </div>
        }
      </div>
     
      {((userRole === 'admin' || userRole === 'superadmin' || userRole === 'client') && clientInfo.user.role_id === client_role_id) &&
        <>
          <hr className="border-t border-gray-200" />
          <h3 className="text-xl font-semibold text-gray-800 p-6">Les domaines</h3>
          <ClientDomainInfo clientId={user.user_id} isAdmin={userRole === 'admin' || userRole === 'superadmin'} />
        </>
      }
      {
        showChangePsw &&
        <ClientPSWChange
          visible={showChangePsw}
          onCancel={() => {
            setShowChangePsw(false)
          }}
          userId={user.user_id}
        />

      }
    </div>
  );
};


const InfoItem = ({ icon, label, value }) => (
  <div className="flex items-center space-x-2">
    <span className="text-xl">{icon}</span>
    <span className="font-medium text-gray-600">{label}:</span>
    <span className="font-semibold">{value}</span>
  </div>
);

const Button = ({ className, onClick, children }) => (
  <button
    className={`px-4 py-2 rounded-md transition duration-300 ease-in-out flex items-center ${className}`}
    onClick={onClick}
  >
    {children}
  </button>
);

export default ClientInfo;
